/**
 * The chat paywall — surfaces a gate `402` as an upsell the user can act on
 * (memory `monetization-onboarding-funnel`: the quota/credit gate IS the paywall
 * funnel). Presentation only: the pure {@link paywallFromError} decides WHEN it
 * shows and WHICH doors to offer; both CTAs open billing (plans + top-up packs),
 * where the actual purchase happens. Non-402 errors never reach here.
 */
import { Button, useT } from '@4f/ui';
import { type JSX, Show } from 'solid-js';
import type { PaywallPrompt } from './paywall-model.ts';

export interface PaywallProps {
  readonly prompt: PaywallPrompt;
  /** Open billing (plans + top-up packs) — both CTAs land here. */
  onOpenBilling(): void;
}

export function Paywall(props: PaywallProps): JSX.Element {
  const { t } = useT();

  return (
    <aside class="f4-paywall" role="alert" aria-label={t(props.prompt.titleKey)}>
      <h3 class="f4-paywall__title">{t(props.prompt.titleKey)}</h3>
      <p class="f4-paywall__body">{t(props.prompt.bodyKey)}</p>
      <div class="f4-paywall__actions">
        <Show when={props.prompt.upsell.upgrade}>
          <Button type="button" variant="primary" onClick={() => props.onOpenBilling()}>
            {t('chat.paywall.upgrade')}
          </Button>
        </Show>
        <Show when={props.prompt.upsell.topUp}>
          <Button type="button" variant="ghost" onClick={() => props.onOpenBilling()}>
            {t('chat.paywall.topUp')}
          </Button>
        </Show>
      </div>
    </aside>
  );
}
